module.exports = __webpack_public_path__ + "img/2ec701a.webp";